import { InjectionToken } from "@angular/core";

export const SW_UPDATE_CHECK_INTERVAL = new InjectionToken<number>('SW_UPDATE_CHECK_INTERVAL');
